// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-content {
  max-width: 960px;
  margin: 24px auto;
  padding: 0 16px;
}

.sign-in-prompt {
  text-align: center;
  margin-top: 80px;
  color: #6b7280;
  font-size: 1.1rem;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB","sourcesContent":[".app-content {\n  max-width: 960px;\n  margin: 24px auto;\n  padding: 0 16px;\n}\n\n.sign-in-prompt {\n  text-align: center;\n  margin-top: 80px;\n  color: #6b7280;\n  font-size: 1.1rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
